export enum StudentQuizChallengeStatus {
	COMPLETED = 'COMPLETED',
	IN_PROGRESS = 'in progress',
	PENDING = 'PENDING',
	AUTO_SUBMITTED = 'auto submitted',
	SUBMITTED = 'submitted'
}